import styled from 'styled-components'
import breakpoint from 'components/breakpoint'

const LogisterFormSubmitButtonContainer = styled.div`
  display: flex;
  flex-direction: column;

  & button {
    width: 100%;
  }

  ${breakpoint('portrait')`
    flex-direction: row;
  `};
`

export default LogisterFormSubmitButtonContainer
